var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProviderGit = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.1388 4.96171L9.87868 4.22182C11.0503 3.05025 12.9498 3.05025 14.1213 4.22183L19.7782 9.87868C20.9498 11.0503 20.9498 12.9497 19.7782 14.1213L14.1213 19.7782C12.9498 20.9497 11.0503 20.9497 9.87868 19.7782L4.22183 14.1213C3.05026 12.9497 3.05026 11.0503 4.22183 9.87868L5.55028 8.55023",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 8H12.75V15.25C12.75 15.6642 12.4142 16 12 16C11.5858 16 11.25 15.6642 11.25 15.25V8Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.52154 5.58209C8.22865 5.2892 8.22865 4.81432 8.52154 4.52143L9.05187 3.9911L16.3085 11.2477C16.6014 11.5406 16.6014 12.0155 16.3085 12.3084C16.0156 12.6013 15.5407 12.6013 15.2478 12.3084L8.52154 5.58209Z",
  fill: "currentColor"
})));
export default SvgProviderGit;